import React from "react";
import Box from "@mui/material/Box";

interface PaperProps {
  children?: React.ReactNode;
}

const Paper: React.FC<PaperProps> = ({ children }) => {
  return (
    <Box
      padding="30px"
      borderRadius="8px"
      boxShadow="0px 10px 25px 0px rgba(0, 0, 0, 0.07)"
      sx={{ backgroundColor: "white" }}
    >
      {children}
    </Box>
  );
};

export default Paper;
